import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

const PrepaidLegal = (props) => {
  const className = classnames('legal', props.className);

  return (
    <div className={className}>
      This card is issued by AF Payments Limited pursuant to a licence by
      Mastercard International.{' '}
      <a
        href="https://www.huggg.me/prepaid-energy-card-terms"
        style={{ color: '#546CD3' }}
      >
        See Terms
      </a>
    </div>
  );
};

PrepaidLegal.propTypes = {
  className: PropTypes.string,
};

export default PrepaidLegal;
